module.exports = __webpack_public_path__ + "img/ua.2243c41f.svg";